import { DictType } from "@pma/types"
import {
  ADD_PROFILE_PICTURE_ENDPOINT,
  ALL_ORG_USERS_ENDPOINT,
  COMPANY_PRINT_ADD_ENDPOINT,
  COMPANY_PRINT_DELETE_ENDPOINT,
  COMPANY_PRINT_GET_ENDPOINT,
  COMPANY_PRINT_UPDATE_ENDPOINT,
  COMPANY_SETTINGS_ENDPOINT,
  COMPANY_SETTINGS_SET_ENDPOINT,
  DELETE_ROLE_DICTIONARY_ENDPOINT,
  DELETE_WMS_ENDPOINT,
  DEPARTMENTS_DICTIONARY_ENDPOINT,
  ADD_WMS_ENDPOINT,
  EDIT_USER_ORG_PARAMETER_ENDPOINT,
  GET_WMS_ENDPOINT,
  GET_NOTIFICATIONS,
  GET_NOTIFICATION_UNREAD_COUNT,
  GET_ORGANIZATION,
  GET_UPDATE_LOGS,
  GET_USER_KANBAN_TASK_COLUMN_ORDER,
  GLOBAL_SEARCH_ENDPOINT,
  PRIORITY_DICTIONARY_ENDPOINT,
  SERVER_URL,
  SET_USER_KANBAN_TASK_COLUMN_ORDER,
  STATUS_DICTIONARY_ENDPOINT,
  ORGANIZATION_SET_TIMEZONE_ENDPOINT,
  USER_LANGUAGE_ENDPOINT,
  UPDATE_WMS_ENDPOINT,
  USER_ORGANIZATION_UPDATE_ENDPOINT,
  USER_ROLE_DICTIONARY_ENDPOINT,
  USER_STATUS_DICTIONARY_ENDPOINT,
  USERS_BY_ID_ENDPOINT,
  GET_USERS_ACCESSES_ENDPOINT,
  USER_ROLE_TRANSFER_ENDPOINT,
  INVITE_USERS_ENDPOINT,
} from "@pma/utils/api-routes"
import axiosServices from "@pma/utils/axios"
import { ACCESS_TOKEN } from "@pma/utils/constants"
import axios from "axios"
import { parseCookies } from "nookies"

export const changeUserDefaultLanguageService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(USER_LANGUAGE_ENDPOINT, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getGlobalSearchFilterService = async (data: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(GLOBAL_SEARCH_ENDPOINT, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getNotificationListService = async (params: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(GET_NOTIFICATIONS, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getNotificationUnreadCountService = async (params: { organization_id: number }) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(GET_NOTIFICATION_UNREAD_COUNT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getUpdateLogsListService = async (params: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(GET_UPDATE_LOGS, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const switchWorkspaceService = async (data: DictType) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(USER_ORGANIZATION_UPDATE_ENDPOINT, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getOrganizationUserListService = async (params: DictType) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(ALL_ORG_USERS_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getUserKanbanColumnOrderService = async (params: DictType) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(GET_USER_KANBAN_TASK_COLUMN_ORDER, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const setUserKanbanColumnOrderService = async (payload: DictType) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(SET_USER_KANBAN_TASK_COLUMN_ORDER, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getUserRoleApi = async (params: DictType) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(USER_ROLE_DICTIONARY_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getUserDetailsService = async (params: any) => {
  const response = await axiosServices.get(USERS_BY_ID_ENDPOINT, { params })
  return response.data
}

export const getOrganizationDetailsService = async (orgId: number) => {
  const response = await axiosServices.get(`${GET_ORGANIZATION}/${orgId}`)
  return response.data
}

export const getOrganizationSettingsService = async (params: any) => {
  const response = await axiosServices.get(COMPANY_SETTINGS_ENDPOINT, { params })
  return response.data
}

export const setOrganizationSettingsService = async (payload: any) => {
  const response = await axiosServices.post(COMPANY_SETTINGS_SET_ENDPOINT, payload)
  return response.data
}

export const addRoleService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(USER_ROLE_DICTIONARY_ENDPOINT + "/add", payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const updateRoleService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(USER_ROLE_DICTIONARY_ENDPOINT + "/edit", payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deleteRoleService = async (roleId: any) => {
  const response = await axiosServices.delete(DELETE_ROLE_DICTIONARY_ENDPOINT + `/${roleId}`)
  return response.data
}

export const getPrinterListService = async (params: any) => {
  const response = await axiosServices.get(COMPANY_PRINT_GET_ENDPOINT, { params })
  return response.data
}

export const addPrinterService = async (payload: any) => {
  const response = await axiosServices.post(COMPANY_PRINT_ADD_ENDPOINT, payload)
  return response.data
}

export const editPrinterService = async (payload: any) => {
  const response = await axiosServices.post(COMPANY_PRINT_UPDATE_ENDPOINT, payload)
  return response.data
}

export const deletePrinterService = async (payload: any) => {
  const response = await axiosServices.delete(COMPANY_PRINT_DELETE_ENDPOINT, { data: payload })
  return response.data
}

export const getDepartmentListService = async (params: any) => {
  const response = await axiosServices.get(DEPARTMENTS_DICTIONARY_ENDPOINT, { params })
  return response.data
}

export const getUserStatusListService = async (params: any) => {
  const response = await axiosServices.get(USER_STATUS_DICTIONARY_ENDPOINT, { params })
  return response.data
}

export const uploadProfileAvatarService = async (formData: any) => {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const response = await axios.post(SERVER_URL + ADD_PROFILE_PICTURE_ENDPOINT, formData, {
    headers: {
      accept: "*/*",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return response.data
}

export const updateUserSettingService = async (payload: any) => {
  const response = await axiosServices.post(EDIT_USER_ORG_PARAMETER_ENDPOINT, payload)
  return response.data
}

export const getTaskStatusListService = async (params: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(STATUS_DICTIONARY_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const addStatusService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(`${STATUS_DICTIONARY_ENDPOINT}/add`, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const updateStatusService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(`${STATUS_DICTIONARY_ENDPOINT}/edit`, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deleteStatusService = async (id: number) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .delete(`${STATUS_DICTIONARY_ENDPOINT}/delete/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const getTaskPrioritiesListService = async (orgId: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .get(PRIORITY_DICTIONARY_ENDPOINT, { params: { organization_id: orgId } })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const addPriorityService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(`${PRIORITY_DICTIONARY_ENDPOINT}/add`, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const updatePriorityService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(`${PRIORITY_DICTIONARY_ENDPOINT}/edit`, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deletePriorityService = async (id: number) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .delete(`${PRIORITY_DICTIONARY_ENDPOINT}/delete/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const getWmsEndpointsService = async (params: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(GET_WMS_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const addWmsEndpointService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(ADD_WMS_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const updateWmsEndpointService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(UPDATE_WMS_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deleteWmsEndpointService = async (params: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .delete(DELETE_WMS_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const getUserAccessesService = async (payload: any) => {
  const response = await axiosServices.post(GET_USERS_ACCESSES_ENDPOINT, payload)
  return response.data
}

export const setOrganizationTimeZoneService = async (payload: {
  organization_id: number
  time_zone: string
}) => {
  const response = await axiosServices.post(ORGANIZATION_SET_TIMEZONE_ENDPOINT, payload)
  return response.data
}

export const setUserProjectRoleTransferService = async (payload: any) => {
  const response = await axiosServices.post(USER_ROLE_TRANSFER_ENDPOINT, payload)
  return response.data
}

export const inviteUserService = async (payload: any) => {
  const response = await axiosServices.post(INVITE_USERS_ENDPOINT, payload)
  return response.data
}

export const removeUserFromOrganizationService = async (payload: any) => {
  const response = await axiosServices.delete(ORGANIZATION_SET_TIMEZONE_ENDPOINT, { data: payload })
  return response.data
}